import { supabase } from "../supabaseClient";

/* ------------------ HELPERS ------------------ */
export const toNumber = (val) => {
  if (val === null || val === undefined || val === "") return 0;
  const num = Number(val);
  return Number.isNaN(num) ? 0 : num;
};

export const getFinancialYearLabel = (value) => {
  if (!value) return "Unknown";

  let date;
  if (typeof value === "number") {
    date = new Date(value);
  } else if (!Number.isNaN(Number(value)) && String(value).length >= 10) {
    date = new Date(Number(value));
  } else {
    date = new Date(value);
  }

  if (isNaN(date.getTime())) return "Unknown";

  const year = date.getFullYear();
  const month = date.getMonth() + 1;

  if (month >= 4) return `FY ${year}-${String(year + 1).slice(-2)}`;
  return `FY ${year - 1}-${String(year).slice(-2)}`;
};

// Returns current FY label e.g. "FY 2025-26"
export const getCurrentFY = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth() + 1;
  const startYear = month >= 4 ? year : year - 1;
  return `FY ${startYear}-${String(startYear + 1).slice(-2)}`;
};

// Returns list of available FYs from FY 2025-26 onwards, most recent first
export const getAvailableFYs = () => {
  const START_YEAR = 2025;
  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth() + 1;

  // Include the FY that has started (April onwards)
  const endYear = currentMonth >= 4 ? currentYear : currentYear - 1;

  const years = [];
  for (let i = START_YEAR; i <= endYear; i++) {
    years.push(`FY ${i}-${String(i + 1).slice(-2)}`);
  }

  // Most recent first
  return years.sort((a, b) => {
    const aYear = Number(a.replace("FY ", "").split("-")[0]);
    const bYear = Number(b.replace("FY ", "").split("-")[0]);
    return bYear - aYear;
  });
};



